import { z } from "zod";

export const updateGroupSchema = z
	.object({
		name: z
			.string()
			.min(2, { message: "Group name must be at least 2 characters" })
			.max(50, { message: "Group name must be at most 50 characters" })
			.optional(),
		description: z.string().max(500).optional(),
		allow_self_join: z.boolean().optional(),
	})
	.strict();

export type UpdateGroupPayload = z.infer<typeof updateGroupSchema>;
